import { PageContent } from "@/app/parts/global/Page";
import * as Api from "@api";
import clsx from "clsx";
import React from "react";
import { PageContentProps } from "../Page";
import { Typography, ProductBadge } from '@/components';
import styles from "./product.module.scss";

interface ProductTitleProps extends React.ComponentPropsWithoutRef<"div">
{
    allowedSubTitles?: string[];
    product?: Api.ProductFull;
    subTitleContentProps?: Partial<PageContentProps>;
    titleContentProps?: Partial<PageContentProps>;
    isCard?: boolean;
    isMenu?: boolean;
}

export const ProductTitle = ({ allowedSubTitles, className, product, subTitleContentProps, titleContentProps, isCard = true, isMenu = false, ...props }: ProductTitleProps): React.ReactComponentElement<"div", ProductTitleProps> | null =>
{
    const titleContent: PageContentProps = {
        ...titleContentProps,
        data: titleContentProps?.data ? titleContentProps?.data : isMenu ? product?.title?.replace("EZ Click ", "").replaceAll("XL", "<strong style=\"font-weight: 900;\">XL</strong>") ?? "" : (product?.title ?? ""),
        typography: titleContentProps?.typography ?? Typography.H5,
        type: titleContentProps?.type ?? product?.title?.includes("XL") ? Api.ContentType.Html : Api.ContentType.Text
    };

    const subTitleContent: PageContentProps = {
        ...subTitleContentProps,
        data: subTitleContentProps?.data ?? product?.subTitle ?? "",
        typography: subTitleContentProps?.typography ?? Typography.P4,
        type: titleContentProps?.type ?? Api.ContentType.Text
    };

    const titleComponent = titleContent.data !== "" ? <PageContent {...titleContent} /> : null;
    const subTitleComponent = subTitleContent.data !== "" && (allowedSubTitles === undefined || allowedSubTitles.includes(subTitleContent.data)) ? <PageContent {...subTitleContent} /> : null;
    const badgeComponents = product !== undefined && product.tags.length > 0 ? product.tags.map(tag => <ProductBadge  key={tag.id} tag={tag} />) : null;

    const classes = clsx(
        styles["title"],
        className
    );
    const isBadgeXl = (titleContent.data !== 'EZ Click XL Glass Plus' && titleContent.data !== 'EZ Click XL Ceramic Pro') || isMenu;

    return (
        <div {...props} className={classes}>
            {titleComponent}
            {/*{subtitleComponent}*/}
            {titleContent.data.includes('XL') && !isMenu
                ? <></>
                : ( isCard ? <div className={clsx(styles['badge'], styles.badgeCard)}>{badgeComponents}</div> : badgeComponents)
            }
        </div>
    );
}
